import { countResumoDg } from './resumoDgCounts'

const UNKNOWN_GROUP = 'Não informado'

const getGroupLabel = (value) =>
  value === null || value === undefined || value === ''
    ? UNKNOWN_GROUP
    : String(value)

const groupRows = (rows, getLabel) => {
  const groups = new Map()
  rows.forEach((row) => {
    const label = getGroupLabel(getLabel(row))
    if (!groups.has(label)) groups.set(label, [])
    groups.get(label).push(row)
  })

  return [...groups.entries()]
    .sort(([left], [right]) => left.localeCompare(right, 'pt-BR'))
    .map(([group, rowsInGroup]) => ({
      group,
      ...countResumoDg(rowsInGroup),
    }))
}

export const buildResumoDgAnalyses = (rows = []) => ({
  general: {
    key: 'general',
    label: 'Geral',
    rows: [{ group: 'Lote', ...countResumoDg(rows) }],
  },
  order: {
    key: 'order',
    label: 'Por Ordem',
    rows: groupRows(rows, (row) => row.ordemMatriz),
  },
  breed: {
    key: 'breed',
    label: 'Por Raça',
    rows: groupRows(rows, (row) => row.racaMatriz),
  },
  bull: {
    key: 'bull',
    label: 'Por Touro',
    rows: groupRows(rows, (row) => row.touro),
  },
})

export const analysisTotalsMatch = (analysis, totalStats) => {
  const totals = analysis.rows.reduce(
    (acc, row) => ({
      total: acc.total + row.total,
      saved: acc.saved + row.saved,
      pending: acc.pending + row.pending,
      pregnant: acc.pregnant + row.pregnant,
      empty: acc.empty + row.empty,
    }),
    { total: 0, saved: 0, pending: 0, pregnant: 0, empty: 0 },
  )

  return ['total', 'saved', 'pending', 'pregnant', 'empty'].every(
    (key) => totals[key] === totalStats[key],
  )
}

export const ANALYSIS_ORDER = ['general', 'order', 'breed', 'bull']
